import websdk from 'easemob-websdk';
import config from './WebIMConfig';
import emoji from './emoji';
import requests from '@/utils/request';
import { message } from 'antd';

// init DOMParser / document for strophe and sdk
let WebIM: any = {};
let WebImEventHandler: any = {};
WebIM['config'] = config;
WebIM['message'] = websdk.message;
WebIM['statusCode'] = websdk.statusCode;
WebIM['utils'] = websdk.utils;
WebIM['logger'] = websdk.logger;
let options = {
  isMultiLoginSessions: WebIM['config'].isMultiLoginSessions,
  isDebug: WebIM['config'].isDebug,
  https: WebIM['config'].https,
  isAutoLogin: false,
  heartBeatWait: WebIM['config'].heartBeatWait,
  autoReconnectNumMax: WebIM['config'].autoReconnectNumMax,
  delivery: WebIM['config'].delivery,
  appKey: WebIM['config'].appkey,
  orgName: WebIM['config'].orgName,
  appName: WebIM['config'].appName,
  client_id: WebIM['config'].client_id,
  client_secret: WebIM['config'].client_secret,
  useOwnUploadFun: WebIM['config'].useOwnUploadFun,
  deviceId: WebIM['config'].deviceId,
  //公有云 isHttpDNS 默认配置为true
  isHttpDNS: WebIM['config'].isHttpDNS,
  onOffline: () => { },
  onOnline: () => { }
};
WebIM['conn'] = new websdk.connection(options);
WebIM['emoji'] = emoji;
// 初始化建立环信监听事件
WebIM['init'] = (context) => {
  WebIM.conn.addEventHandler('connection&message', {
    onOpened: function () {
      console.log('[WebIM] onOpened,登录环信成功');
      const { onOpenedHandler } = WebImEventHandler;
      if (onOpenedHandler) {
        onOpenedHandler();
      }
    },
    // SDK 与环信服务器连接成功。
    onConnected: function (message) {
      console.info('[WebIM] 连接成功', new Date().getTime());
      const { onConnectedHandler } = WebImEventHandler;
      if (onConnectedHandler) {
        onConnectedHandler();
      }
    },
    // SDK 与环信服务器断开连接。
    onDisconnected: function (message) {
      console.info('[WebIM] 断开连接', new Date().getTime());
      const { disConnectedHandler } = WebImEventHandler;
      if (disConnectedHandler) {
        disConnectedHandler()
      }
    },
    // 当前用户收到文本消息。
    onTextMessage: function (message) {
      console.log('发送文本消息')
      const { to, chatType } = message;
      const imUserRespVO = JSON.parse(localStorage.getItem('imUserRespVO'));
      const { imUsername = '' } = imUserRespVO;
      if (to == imUsername || chatType == 'groupChat') {
        const { textMessageHandler, sendReadHandler } = WebImEventHandler;
        // textMessageHandler  undefined  需要显示爆炸图
        if (textMessageHandler) {
          textMessageHandler(message);
          // sendReadHandler(message);  // todo
        } else {
          context.updatehWebImNum();
        }
      } else {
        console.log('接收消息事件：不是接收人');
      }
    },
    // 当前用户收到图片消息。
    onImageMessage: function (message) {
      console.info('[WebIM] 收到一条新的图片消息：', message);
      const { to, chatType } = message;
      const imUserRespVO = JSON.parse(localStorage.getItem('imUserRespVO'));
      const { imUsername = '' } = imUserRespVO;
      if (to == imUsername || chatType == 'groupChat') {
        const { imageMessageHandler, sendReadHandler } = WebImEventHandler;
        if (imageMessageHandler) {
          imageMessageHandler(message);
          sendReadHandler(message);
        } else {
          console.log('onImageMessage')
          // context.updateImMsgCnt({ type: 'plus' });
          context.updatehWebImNum();
        }
      } else {
        console.log('接收消息事件：不是接收人');
      }
    },
    // 当前用户收到透传消息。
    onCmdMessage: function (message) { },
    // 当前用户收到语音消息。
    onAudioMessage: function (message) { },
    // 当前用户收到位置消息。
    onLocationMessage: function (message) { },
    // 当前用户收到文件消息。
    onFileMessage: function (message) {
      console.log('收到文件消息');
      const { to, chatType } = message;
      const imUserRespVO = JSON.parse(localStorage.getItem('imUserRespVO'));
      const { imUsername = '' } = imUserRespVO;
      if (to == imUsername || chatType == 'groupChat') {
        const { fileMessageHandler, sendReadHandler } = WebImEventHandler;
        if (fileMessageHandler) {
          fileMessageHandler(message);
          sendReadHandler(message);
        } else {
          console.log('onFileMessage')
          // context.updateImMsgCnt({ type: 'plus' });
          context.updatehWebImNum();
        }
      } else {
        console.log('接收消息事件：不是接收人');
      }
    },
    // 当前用户收到自定义消息。
    onCustomMessage: function (message) {
      console.log('收到自定义消息');
      const { to, chatType } = message;
      const imUserRespVO = JSON.parse(localStorage.getItem('imUserRespVO'));
      const { imUsername = '' } = imUserRespVO;
      if (to == imUsername || chatType == 'groupChat') {
        const { customMessageHandler, sendReadHandler } = WebImEventHandler;
        if (customMessageHandler) {
          customMessageHandler(message);
          sendReadHandler(message);
        } else {
          console.log('onCustomMessage')
          // context.updateImMsgCnt({ type: 'plus' });
          context.updatehWebImNum();
        }
      } else {
        console.log('接收消息事件：不是接收人');
      }
    },
    // 当前用户收到视频消息。
    onVideoMessage: function (message) { },
    // 当前用户订阅的其他用户的在线状态更新。
    onPresence: function (message) { },
    // 当前用户收到好友邀请。
    onContactInvited: function (msg) { },
    // 联系人被删除。
    onContactDeleted: function (msg) { },
    // 新增联系人。
    onContactAdded: function (msg) { },
    // 当前用户发送的好友请求被拒绝。
    onContactRefuse: function (msg) { },
    // 当前用户发送的好友请求被同意。
    onContactAgreed: function (msg) { },
    // 当前用户收到群组邀请。
    onGroupEvent: function (message) { },
    // 本机网络连接成功。
    onOnline: function () { },
    // 本机网络掉线。
    onOffline: function () { },
    // 调用过程中出现错误。
    onError: function (error) {
      // console.log('onError', error);
      const { errorHandler } = WebImEventHandler;
      if (errorHandler) {
        errorHandler(error)
      }
      // 16: server-side close the websocket connection
      // if (error.type == WebIM.statusCode.WEBIM_CONNCTION_DISCONNECTED) {
      //   console.log(
      //     'WEBIM_CONNCTION_DISCONNECTED',
      //     WebIM.conn.autoReconnectNumTotal,
      //     WebIM.conn.autoReconnectNumMax
      //   )
      //   if (WebIM.conn.autoReconnectNumTotal < WebIM.conn.autoReconnectNumMax) {
      //     return
      //   }
      //   message.error('服务端已关闭 websocket 链接')
      //   // WebIM.login();
      //   return
      // }
      // // 2: login by token failed
      // if (error.type == WebIM.statusCode.WEBIM_CONNCTION_AUTH_ERROR) {
      //   message.error('WebIM 链接鉴权失败')
      //   return
      // }

      // // 8: offline by multi login
      // if (error.type == WebIM.statusCode.WEBIM_CONNCTION_SERVER_ERROR) {
      //   message.error('多重登录，已离线')
      //   // WebIM.login();
      //   return
      // }
      // if (error.type == WebIM.statusCode.WEBIM_CONNCTION_USER_REMOVED) {
      //   message.error('用户下线')
      //   // WebIM.login();
      //   return
      // }
      // if (error.type == WebIM.statusCode.WEBIM_CONNCTION_USER_LOGIN_ANOTHER_DEVICE) {
      //   message.error('账户在另外一台设备登录，请先在另一设备退出登录')
      //   // WebIM.login();
      //   return
      // }
    },
    // 当前用户收到的消息被消息发送方撤回。
    onRecallMessage: function (message) {
      const { recallMessageHandler } = WebImEventHandler;
      recallMessageHandler(message);
    },
    // 当前用户发送的消息被接收方收到。
    onReceivedMessage: function (message) { },
    // 当前用户收到消息送达回执。
    onDeliveredMessage: function (message) {
      // console.log(message, 'message')
    },
    // 当前用户收到消息已读回执。
    onReadMessage: function (message) {
      console.info('[WebIM] 收到消息已读的回执：', message);
      const { from, to, chatType } = message;
      const imUserRespVO = JSON.parse(localStorage.getItem('imUserRespVO'));
      const { imUsername = '' } = imUserRespVO;
      // 当前登录人已读，数量减一
      if (from == imUsername) {
        const { readMessageHandler } = WebImEventHandler;
        if (readMessageHandler) {
          readMessageHandler(message);
        }
        //  else {
        //   console.log('onReadMessage')
        //   context.updateImMsgCnt({ type: 'minus' });
        // }
      }
      // 对方已读，修改页面的已读状态
      else {
        const { readMessageHandler } = WebImEventHandler;
        if (readMessageHandler) {
          readMessageHandler(message);
        } else {
          // console.log('已读回执事件：readMessageHandler 未绑定回调函数');
        }
      }
    },
    // 当前用户收到会话已读回执。
    onChannelMessage: function (message) {
      console.info('[WebIM] 收到会话消息已读的回执：', message);
      const { from, to, chatType } = message;
      const imUserRespVO = JSON.parse(localStorage.getItem('imUserRespVO'));
      const { imUsername = '' } = imUserRespVO;
      // 当前登录人已读，数量减一
      if (to == imUsername) {
        const { channelMessageHandler } = WebImEventHandler;
        if (channelMessageHandler) {
          channelMessageHandler(message);
        }
      }
    },
    onTokenWillExpire: () => {
      console.log("onTokenWillExpire");
    },
    onTokenExpired: () => {
      console.log("onTokenExpired");
    },
  });
};
// 绑定回调事件
WebIM['bind'] = (eventHandler, callback) => {
  WebImEventHandler = eventHandler;
  callback();
};
// WebIM 登录
WebIM['login'] = (callback) => {
  const imUserRespVO = localStorage.getItem('imUserRespVO') ? JSON.parse(localStorage.getItem('imUserRespVO')) : {};
  if (!!imUserRespVO) {
    const { imUsername = '', imPassword = '' } = imUserRespVO;
    WebIM['conn']
      .open({ user: imUsername, pwd: imPassword })
      .then((res) => {
        callback && callback(true)
      })
      .catch((error) => {
        throw error;
      });
  }
};

export default WebIM;
